import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  to: string;
  type: string;
  body: string;
  from_number?: string;
}
type MutationResponse = {
  timestamp: string,
  statusCode: number,
  status: string,
  message: string,
  data: any
};

export const useWhatsappSendMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp message sending',
    endpoint: '/api/admin/whatsapp/send',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};